<template>
  <p class="paragraph" :class="attrClass">
    <slot></slot>
  </p>
</template>

<script>
export default {
  components: {
    // 'render-title':
  },
  props: {
    config: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    attrClass(){
      let classStr = '';

      if (this.config.attrs){
        if (this.config.attrs.textAlign){
          classStr += this.config.attrs.textAlign;
        }
      }
      return classStr;
    }
  }
};
</script>

<style lang="scss" scoped>
.paragraph {
  text-align: left;

  &.center {
    text-align: center;
  }

  &.right {
    text-align: right;
  }
}
</style>